import { Component } from 'opus-angular-seed-core';

@Component({
    transclude: true,
    template: `
        <p class="alert alert-success" ng-transclude></p>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/alert/success/index.js